import { Kacheln } from '../components/Kacheln';

/**
 * Die Startseite.
 *
 * Nichts als das Kachelfeld. Wer nach der Anmeldung ankommt, soll sehen, was
 * es gibt - und nicht erst an Kennzahlen vorbeiscrollen, die ihn in diesem
 * Moment womöglich gar nicht interessieren. Die Zahlen stehen einen Klick
 * weiter unter *Kennzahlen*.
 */
export function StartPage() {
  return <Kacheln />;
}
